














import { Component, Vue, Prop } from 'vue-property-decorator';
// import { HelpService } from '@/api/com/MetaPattern/APP/Sys/Help/HelpService';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';

@Component({
  components: {}
})
export default class HelpIcon extends Vue {
  @Prop() private code?: string;
  @Prop() private content?: string;
  @Prop() private linkStyle?: string;
  private visible = false;
  private helpContent = '';
  private linkStyleContent = '';
  private isLoaded = false;

  constructor() {
    super();
    this.visible = false;
    this.helpContent = '加载中...';
    this.linkStyleContent = 'padding:0px;font-size:10px;';
    this.isLoaded = false;
  }

  mounted() {
    if (ValidateHelper.IsNotNullOrEmpty(this.content)) {
      this.helpContent = this.content;
    }
    if (ValidateHelper.IsNotNullOrEmpty(this.linkStyle)) {
      this.linkStyleContent += this.linkStyle;
    }
  }

  getHelpContent() {
    if (this.visible && !this.isLoaded) {
      this.isLoaded = true;
      if (ValidateHelper.IsNotNullOrEmpty(this.code)) {
        const codes = new Array<string>();
        codes.push(this.code);
        this.helpContent = '未实现';
        // TODO 改为从Java的sys服务获取
        // HelpService.GetHelpItemsByCodeAsync(codes)
        //   .then(helpItems => {
        //     if (helpItems.length > 0) {
        //       this.helpContent = helpItems[0].content;
        //     }
        //   });
      }
    }
    return this.helpContent;
  }
}
